import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {contextPath} from "site";
import {Observable} from "rxjs";

import {ConnectedCockpitOemAvdbTrialRequest} from "./connected-cockpit-oem-avdb-trial-request";
import {ConnectedCockpitOemAvdbTrialResponse} from "./connected-cockpit-oem-avdb-trial-response";
import {ConnextActivationRequest} from "./connext-activation-request";
import {ConnextActivationResponse} from "./connext-activation-response";
import {OrgService} from "./shared/org.service";

const apiURL = `${contextPath}/api/oem`;

@Injectable()
export class OemService {
	constructor(
		private http: HttpClient,
		private orgService: OrgService
	) {}

	activateConnextTrial(request: ConnextActivationRequest): Observable<ConnextActivationResponse> {
		return this.http.post<ConnextActivationResponse>(`${apiURL}/activate-connext-trial`, request, {headers: this.orgService.contextHttpHeader})
			.map(response => ConnextActivationResponse.fromJSON(response));
	}

	activateAvdbTrial(request: ConnectedCockpitOemAvdbTrialRequest): Observable<ConnectedCockpitOemAvdbTrialResponse> {
		return this.http.post<ConnectedCockpitOemAvdbTrialResponse>(`${apiURL}/activate-avdb-trial`, request, {headers: this.orgService.contextHttpHeader})
			.map(response => ConnectedCockpitOemAvdbTrialResponse.fromJSON(response));
	}

	canActivateAvdbTrial(masterAircraftUuid: String): Observable<Boolean> {
		return this.http.get<Boolean>(`${apiURL}/${masterAircraftUuid}/can-activate-avdb-trial`, {headers: this.orgService.contextHttpHeader})
			.map(Boolean);
	}
 }
